export default __webpack_public_path__ + "static/media/icon-strategy.4b8d35c6.svg";